import { render, staticRenderFns } from "./InHospital.vue?vue&type=template&id=56872ade"
import script from "./InHospital.vue?vue&type=script&lang=js"
export * from "./InHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports